import { FETCH_MontantInvest_SUCCESS, FETCH_MontantInvest_FAILURE,REDIRECT_TO_LOGIN } from './actionsTypes';

const initialState = {
  montantInvestData: [],
  error: null,
  redirectToLoginPage: false,
};

const MontantInvestDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_MontantInvest_SUCCESS:
      return {
        ...state,
        montantInvestData: action.payload.montantInvestData,
        error: null,
      };
    case FETCH_MontantInvest_FAILURE:
      return {
        ...state,
        montantInvestData: [],
        error: action.payload.error,
      };
    case REDIRECT_TO_LOGIN:
        return {
            ...state,
            redirectToLoginPage: true,
        };
    default:
      return state;
  }
};

export default MontantInvestDataReducer;
